import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import CssBaseline from '@material-ui/core/CssBaseline';

import Link from '@material-ui/core/Link';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import StyleSelector from "../components/StyleSelector.js";
import Backdrop from "@material-ui/core/Backdrop";
import DownloadIcon from "@material-ui/icons/GetApp";

import ImageUploader from "react-images-upload";
import ReactCompareImage from "react-compare-image";
import * as loadImage from "blueimp-load-image";

import GridLoader from "react-spinners/GridLoader";
import beforePlaceholder from "../images/before.jpg";
import afterPlaceholder from "../images/after.jpg";
import logo from "../images/logo.png";

import { triggerBase64Download } from "react-base64-downloader";
import { transform } from "../api.js";
import { toDataUrl } from "../utils.js";
//import  Button  from "../components/Button.js";
import StarRating from "../components/StarRating.js";
import FetchQuote from "../components/quoteFetcher.js";

import ImageGridList from "../components/GalleryGrid.js";


import ShareButtons from "../components/share-buttons/share.component";

const LOAD_SIZE = 450;
const WIDTH = 400;
const PAPER_URL = "https://openaccess.thecvf.com/content_cvpr_2018/papers/Chen_CartoonGAN_Generative_Adversarial_CVPR_2018_paper.pdf";

const title = "Cartoonish Canvas - MISABANITA";
const url = "https://misabanita.netlify.app";
const twitterHandle = "_MiSabanita";
const tags = ["ArtificialIntelligence","NeuralNetworks","Cartoonish","Funny", "Easy"];
//const quote = "¿Cómo sería una versión caricatura tuya? Ahora es facil averiguarlo"

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "80%",
    margin: theme.spacing(1),
  },
  holder: {
    width: WIDTH,
    maxWidth: 400,
    margin: 10,
  },
  chip: {
    width: 200,
    backgroundColor: "#e63946",
    margin: 10,
    fontWeight: "bold",
  },
  logo: {
    width: WIDTH * 0.8,
    marginTop: 10,
    marginLeft: 20,
  },
 root: {
    height: '100vh',
  },
  row1: {
    minHeight: '100%',
  },
  row2: {
    textAlign: 'center',
    backgroundColor:"#f5f5f5",
  },
  rowGalleryGrid: {
    textAlign: 'center',
    backgroundColor:"#f5f5f5",
  },
  row3: {
    textAlign: 'center',
    backgroundColor:"black",
  },
  image: {
    width: '100%',
    paddingTop:50,
    paddingBottom: 50,
    backgroundImage: 'url(https://source.unsplash.com/random)',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',

  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));





export default function Home() {
  const [before, setBefore] = useState("");
  const [after, setAfter] = useState("");
  const [photoName, setPhotoName] = useState("default");
  const [percentage, setPercentage] = useState(0.5);
  const [modelID, setModelID] = useState(0);
  const [open, setOpen] = useState(false);
  const [show, toggleShow] = useState(false);

  useEffect(() => {
    toDataUrl(beforePlaceholder, (base64) => {
      setBefore(base64);
    });
  }, []);

  useEffect(() => {
    toDataUrl(afterPlaceholder, (base64) => {
      setAfter(base64);
    });
  }, []);

  useEffect(() => {
    document.title = title;
  }, []);

  const classes = useStyles();


  return (
          <Grid container component="main" className={classes.root} >
      <CssBaseline />
       <Grid container item xs={12} className={classes.row1}>
            <Grid item xs={false} sm={5} md={7} className={classes.image} >
                <div class="contentCenter">
                    <FetchQuote/>
                </div>
            
            </Grid>
            <Grid item xs={12} sm={7} md={5} component={Paper} elevation={6} square>
              <div className={classes.paper}>
                  <Box align="center">
                    <div style={{ textAlign: "center", width: "100%" }}>
                      <img src={logo} className={classes.logo} alt="ccanvas-misabanita"/>
                    </div>
                    <div className={classes.holder}>

                      <div class="shadowBoxContainer"> 
                        <StyleSelector
                          modelID={modelID}
                          setModelID={setModelID}
                          setPercentage={setPercentage}
                          setOpen={setOpen}
                          before={before}
                          LOAD_SIZE={LOAD_SIZE}
                          NAME={photoName}
                          setAfter={setAfter}
                        />
                       </div> 
                      <div class="shadowBoxRight"> 
                        <ImageUploader
                          singleImage
                          buttonText="Seleccionar foto"
                          onChange={(pictureFiles, pictureDataURL) => {
                            setOpen(true);
                            setPercentage(1);

                            loadImage(
                              pictureDataURL[0],
                              (cnv) => {
                                setBefore(cnv.toDataURL());
                                setAfter(cnv.toDataURL());
                                const data = {
                                  image: cnv.toDataURL(),
                                  model_id: modelID,
                                  load_size: LOAD_SIZE,
                                  name: 'new',
                                };
                                transform(data)
                                  .then((response) => {
                                    console.log("success");
                                    console.log(response.data);
                                    setAfter(response.data.output);
                                    setPhotoName(response.data.name);
                                    setPercentage(0.0);
                                    setOpen(false);
                                  })
                                  .catch((response) => {
                                    console.log(response);
                                  });
                              },
                              {
                                orientation: true,
                                canvas: true,
                                crossOrigin: "anonymous",
                                maxWidth: 600,
                              }
                            );
                          }}
                          imgExtension={[".jpg", ".gif", ".png", ".gif", "jpeg"]}
                          maxFileSize={5242880}
                        />
                      </div>
                      <div class=""> 

                        <ReactCompareImage
                          aspectRatio="wider"
                          leftImage={before}
                          rightImage={after}
                          leftImageLabel="Before"
                          rightImageLabel="After"
                          sliderPositionPercentage={percentage}
                          sliderLineColor="yellow"
                          leftImageCss={{ borderRadius: 10 }}
                          rightImageCss={{ borderRadius: 10 }}
                        />
                      </div>

                      <Chip
                        color="secondary"
                        label="Descargar"
                        className={classes.chip}
                        icon={<DownloadIcon style={{ marginTop: 4 }} />}
                        onClick={() => {
                          triggerBase64Download(after, "styled_image");
                        }}
                      />
                    </div>
                    <Backdrop
                      open={open}
                      style={{ zIndex: 999 }}
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <GridLoader size={30} margin={2} color="#e63946" />
                    </Backdrop>
                    <div>
                      <div id="share-text">Si te gusto, compartela con tus amigos!</div>
                        <ShareButtons title={title} url={url} twitterHandle={twitterHandle} tags={tags}/>
                    </div>

                  </Box>

              </div>
            </Grid>
        </Grid>

        <Grid item xs={12} className={classes.rowGalleryGrid}>
            <ImageGridList/>
        </Grid>
      
        <Grid item xs={12} className={classes.row2}>
            <StarRating/>
        </Grid>



      <Grid item xs={12} className={classes.row3}>

       {show && <div id="notes-app">
                <div class="line"></div>
                <label class="bold">Informativo:</label>  
                <div class="note-text text-justify">
                    Este es un proyecto piloto de investigación y despliegue de la aplicación de las redes neuronales profundas
                    en el procesamiento de imágenes y posterior transformación surrealista. 
                    Implementado únicamente con fines académicos
                    y entrenimiento. Su desarrollo y despliegue final ha sido posible en colaboración
                     con grandes colegas apasionados de la inteligencia artificial.
                    Este proyecto esta basado en el paper "CartoonGAN: Generative Adversarial Networks for Photo Cartoonization".
                    <Link href={PAPER_URL} target="_blank">
                      Leer más
                    </Link>
                </div>
                <div class="line"></div>
                <label class="bold">Advertencia:</label>  
                <div class="note-text text-center">
                  No recopilamos ni almacenamos información sensible vuestra, como las fotografías. Tenga cuidado y disfrute de la app!
                </div>
              </div>}

          <div>
              <button id="hide-show-btn" onClick={() => toggleShow(!show)}>{show ? <ExpandMoreIcon/> : <ExpandLessIcon/>} Políticas de uso</button>    
             
          </div>

      </Grid>
      

    </Grid>
  );
}
